module.exports = __webpack_public_path__ + "rijksoverheidsanstext-bold_2_0.woff2?58143c4763046f1518d4ca7d02937c81";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/rijksoverheidsanstext-bold_2_0.woff2
// module id = 541
// module chunks = 0